<template>
  <div style="max-width: 750px">
    <v-layout>
      <v-flex xs9>
        <v-card-title>
          {{ title }}
        </v-card-title>
      </v-flex>
      <v-flex xs3>
        <v-btn block round color="blue-grey" dark :to="{ name: 'schema-template-upload', params: { schemaId: $route.params.schemaId } }">
          <span style="margin-right: 15px; font-weight: bold; color: #efefef">{{ $t('templates.list.add-new') }}</span>
          <v-icon>note_add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="templates"
      :loading="loading"
      :rows-per-page-text="tableTranslations.rowsPerPageText"
      :no-data-text="tableTranslations.noDataText"
      :no-results-text="tableTranslations.noResultsText"
      :rows-per-page-items="pagination.rowsPerPageItems"
      :pagination.sync="pagination"
      class="elevation-1">
      <v-progress-linear slot="progress" color="primary" indeterminate ></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td class="text-xs-right">{{ props.index + 1 }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.status }}</td>
        <td>
          <v-btn small round block color="blue-grey darken-2" @click="print(props.item)">
            <span style="margin-right: 10px; font-weight: bold; color: #efefef">DOCX</span>
            <v-icon style="color: #efefef">file_copy</v-icon>
          </v-btn>
        </td>
        <td>
          <v-btn block round small dark color="deep-orange darken-3" @click="remove(props)">
            <v-icon>delete_forever</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import http from '@/plugins/http'

export default {
  data() {
    return {
      pagination: this.$store.getters.pagination,
      loading: false,
      schema: null,
      templates: []
    }
  },
  computed: {
    tableTranslations() {
      return this.$store.getters.tableTranslations
    },
    title() {
      return this.$t('templates.list.title', { 'schema-name': (this.schema != null) ? this.schema.name : "" })
    },
    headers() {
      return [
        {
          text: this.$t('base.id'),
          value: 'id',
          align: 'right'
        },
        {
          text: this.$t('templates.list.name'),
          value: 'name',
          width: '35%',
          align: 'left'
        },
        {
          text: this.$t('templates.list.status'),
          value: 'status',
          align: 'center'
        },
        {
          text: this.$t('templates.list.download'),
          sortable: false,
          align: 'center'
        },
        {
          text: this.$t('templates.list.deleting'),
          sortable: false,
          align: 'center'
        }
      ]
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      axios.all([
        http.get('schema/' + this.$route.params.schemaId),
        http.get('templates/' + this.$route.params.schemaId)
      ]).then(axios.spread((schema, templates) => {
        this.schema = schema.data
        this.templates = templates.data
        this.loading = false
      }))
    },
    print(item) {
      this.loading = true
      http({
        url: '/template/' + item.id + '/print',
        method: 'GET',
        responseType: 'blob'
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', item.name + '.docx')
            document.body.appendChild(link)
            link.click()
            this.loading = false
          });
    },
    remove(props) {
      this.$confirm(this.$t('templates.list.delete.confirmation', { "template-name": props.item.name }))
          .then(res => {
            if (res) {
              this.loading = true
              http.delete('template/' + props.item.id)
                  .then(() => {
                    this.loading = false
                    this.templates.splice(props.index, 1)
                    this.$store.commit('setSnack', {
                      message: this.$t('templates.list.delete.success-message'),
                      color: 'success'
                    })
                  }).catch(() => {
                this.$store.commit('setSnack', {
                  message: this.$t('templates.list.delete.error-message'),
                  color: 'warning'
                })
                this.loading = false
              })
            }
          })
    }
  },
}
</script>

<style scoped>
</style>
